<template>
          <div class="home_footer">
            <p class="copy">Copyright 2022. SAMSUNG SDS. All rights reserved.</p>
            <ul>
              <!-- <li><a @click="onClickMainMenu(menuType.service)">서비스 이용약관</a></li> -->
              <li><a href="#" @click="onClickPersonalInfo()"><span style="font-weight:bold;">개인정보 처리방침</span></a></li>
            </ul>
            <p class="footer_logo">SAMSUNG SDS</p>
          </div>
</template>
<script>

import AICCLnb from '../AICCLnb/AICCLnb';

export default {
    name: 'aicc-footer',
    components: {
        aiccLnb: AICCLnb,
    },

    data() {
        return {
        }
    },
    created(){
        
    },
    mounted(){
    },
    beforeDestroy() {
    },
    watch:{
        lnbShowed(){
            this.checkContentsSize(true);
        },
        lnbCollapsed(){
            this.checkContentsSize(true);
        },
    },
    computed:{

           
        },
    methods:{
        onClickPersonalInfo(){
            this.$emit('onClickPersonalInfo');
        },
    },

}
</script>
